module.exports = __webpack_public_path__ + "media/images/fut-desktop-xl-f51604c6453b83eed26919794218082b.jpg";